export class LangConfig {
  label: string;
  abbv: string;
  iso: string;
}
